

// import React, { useEffect, useState } from "react";
// import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
// import { Search, ChevronRight, X, Clock, UserCheck, UserMinus, CalendarDays } from "lucide-react";
// import AttendanceLoader from "./AttendanceLoader";
// import "../styles/AttendanceReport.css";

// function AttendanceReport() {
//   const [search, setSearch] = useState("");
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [dailyFilter, setDailyFilter] = useState("ALL"); // ALL, P, A, LATE, LEAVE

//   const parseJsonSafe = (text) => {
//     const jsonStart = text.search(/[\{\[]/);
//     if (jsonStart !== -1) {
//       return JSON.parse(text.substring(jsonStart));
//     }
//     return JSON.parse(text);
//   };

//   useEffect(() => {
//     fetch("/gt-api/get_attendance_report.php")
//       .then((res) => res.text())
//       .then((text) => parseJsonSafe(text))
//       .then((result) => {
//         setData(Array.isArray(result) ? result : []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Fetch Error:", err);
//         setLoading(false);
//       });
//   }, []);

//   const filteredData = data.filter((row) =>
//     row.name.toLowerCase().includes(search.toLowerCase())
//   );

//   const handleEmployeeClick = async (emp_code) => {
//     try {
//       setDailyFilter("ALL");
//       const res = await fetch(`/gt-api/get_employee_attendencedetail.php?emp_code=${emp_code}`);
//       const text = await res.text();
//       const result = parseJsonSafe(text);
//       setSelectedEmployee(result);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleCardClick = (filterType) => {
//     if (dailyFilter === filterType) {
//       setDailyFilter("ALL");
//     } else {
//       setDailyFilter(filterType);
//     }
//   };

//   const getFilteredDaily = () => {
//     if (!selectedEmployee?.daily) return [];
//     if (dailyFilter === "P") return selectedEmployee.daily.filter(d => d.status === "P");
//     if (dailyFilter === "A") return selectedEmployee.daily.filter(d => d.status === "A" || d.status === "Absent");
//     if (dailyFilter === "LATE") return selectedEmployee.daily.filter(d => d.late || d.status.includes("Late"));
//     if (dailyFilter === "LEAVE") {
//       return selectedEmployee.daily.filter(d => 
//         (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type || d.remark?.toLowerCase().includes("leave")
//       );
//     }
//     return selectedEmployee.daily;
//   };

//   const COLORS = ["#22c55e", "#ef4444", "#f59e0b"];

//   if (loading) {
//     return (
//       <AttendanceLoader 
//         message="Fetching Attendance Report..." 
//         subtitle="Please wait a moment while employee punch records and monthly summaries are processed." 
//       />
//     );
//   }

//   return (
//     <div className="EmployeePunch">
//       {/* LEFT: MAIN LIST */}
//       <div className={`empppunchmain ${selectedEmployee ? "emppunchactive" : ""}`}>
//         <div className="emppunchtopbar">
//           <h2 className="emppunchtitle">Attendance Report</h2>
//           <div className="emppunchsearch">
//             <Search size={18} className="emppunchsearchicon" />
//             <input
//               type="text"
//               placeholder="Search employee..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               className="emppunchsearchfield"
//             />
//           </div>
//         </div>

//         <div className="emppunchtbl">
//           <table className="emppunchmaintable">
//             <thead>
//               <tr>
//                 <th>Employee</th>
//                 <th>Present</th>
//                 <th>Absent</th>
//                 <th>Late</th>
//                 <th></th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData.map((row, index) => (
//                 <tr key={index} onClick={() => handleEmployeeClick(row.emp_code)} className={selectedEmployee?.emp_code === row.emp_code ? "emppunchrowselected" : ""}>
//                   <td>
//                     <div className="emppunchprofile">
//                       <div className="emppunchavatar">{row.name.charAt(0)}</div>
//                       <div>
//                         <div className="emppunchnamebold">{row.name}</div>
//                         <div className="emppunchidsub">{row.emp_code}</div>
//                       </div>
//                     </div>
//                   </td>
//                   <td className="emppunchtxtp">{row.present}</td>
//                   <td className="emppunchtxta">{row.absent}</td>
//                   <td className="emppunchtxtl">{row.late}</td>
//                   <td><ChevronRight size={18} color="#94a3b8" /></td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* RIGHT: DETAIL PANEL */}
//       {selectedEmployee && (
//         <div className="emppunchdetailpanel">
//           <div className="emppunchpanelheaderblue">
//             <div className="emppunchpaneluser">
//               <div className="emppunchavatarwhite">{selectedEmployee.name.charAt(0)}</div>
//               <h3>{selectedEmployee.name} <span className="emppunchidtag">({selectedEmployee.emp_code})</span></h3>
//             </div>
//             <button className="emppunchpanelclose" onClick={() => setSelectedEmployee(null)}><X size={20} /></button>
//           </div>

//           <div className="emppunchpanelcontentscrollable">
//             {/* 4 INTERACTIVE STAT CARDS / TABS */}
//             {(() => {
//               const leaveCount = selectedEmployee?.summary?.leave !== undefined
//                 ? selectedEmployee.summary.leave
//                 : (selectedEmployee?.daily?.filter(d => 
//                     (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type || d.status?.toLowerCase().includes("leave")
//                   ).length || 0);

//               return (
//                 <div className="emppunchstatscards">
//                   <div 
//                     className={`emppunchcarditem emppunchcpresent ${dailyFilter === 'P' ? 'emppunchcardactive' : ''}`}
//                     onClick={() => handleCardClick('P')}
//                     style={{ cursor: "pointer" }}
//                     title="Click to filter Present days"
//                   >
//                     <UserCheck size={18} color="#22c55e" />
//                     <div><p>Present</p><strong>{selectedEmployee.summary?.present || 0}</strong></div>
//                   </div>

//                   <div 
//                     className={`emppunchcarditem emppunchcabsent ${dailyFilter === 'A' ? 'emppunchcardactive' : ''}`}
//                     onClick={() => handleCardClick('A')}
//                     style={{ cursor: "pointer" }}
//                     title="Click to filter Absent days"
//                   >
//                     <UserMinus size={18} color="#ef4444" />
//                     <div><p>Absent</p><strong>{selectedEmployee.summary?.absent || 0}</strong></div>
//                   </div>

//                   <div 
//                     className={`emppunchcarditem emppunchclate ${dailyFilter === 'LATE' ? 'emppunchcardactive' : ''}`}
//                     onClick={() => handleCardClick('LATE')}
//                     style={{ cursor: "pointer" }}
//                     title="Click to filter Late marks"
//                   >
//                     <Clock size={18} color="#f59e0b" />
//                     <div><p>Late</p><strong>{selectedEmployee.summary?.late || 0}</strong></div>
//                   </div>

//                   <div 
//                     className={`emppunchcarditem emppunchcleave ${dailyFilter === 'LEAVE' ? 'emppunchcardactive' : ''}`}
//                     onClick={() => handleCardClick('LEAVE')}
//                     style={{ cursor: "pointer" }}
//                     title="Click to filter Leave days"
//                   >
//                     <CalendarDays size={18} color="#8b5cf6" />
//                     <div><p>Leave</p><strong>{leaveCount}</strong></div>
//                   </div>
//                 </div>
//               );
//             })()}

//             <div className="emppunchanalyticssectionwhite">
//               <h4>Attendance Overview</h4>
//               <div className="emppunchchartbox">
//                 <div className="emppunchchartleft">
//                   <ResponsiveContainer width="100%" height={200}>
//                     <PieChart>
//                       <Pie
//                         data={[
//                           { name: "Present", value: Number(selectedEmployee.summary?.present || 0) },
//                           { name: "Absent", value: Number(selectedEmployee.summary?.absent || 0) },
//                           { name: "Late", value: Number(selectedEmployee.summary?.late || 0) }
//                         ]}
//                         cx="50%"
//                         cy="50%"
//                         outerRadius={80}
//                         innerRadius={0}
//                         dataKey="value"
//                         stroke="#fff"
//                         strokeWidth={2}
//                       >
//                         {COLORS.map((color, i) => (
//                           <Cell key={`cell-${i}`} fill={color} />
//                         ))}
//                       </Pie>
//                       <Tooltip />
//                     </PieChart>
//                   </ResponsiveContainer>
//                 </div>

//                 <div className="emppunchchartlegendright">
//                   <div className="emppunchlegendrow"><span className="emppunchdot" style={{ backgroundColor: COLORS[0] }}></span> Present ({selectedEmployee.summary?.present})</div>
//                   <div className="emppunchlegendrow"><span className="emppunchdot" style={{ backgroundColor: COLORS[1] }}></span> Absent ({selectedEmployee.summary?.absent})</div>
//                   <div className="emppunchlegendrow"><span className="emppunchdot" style={{ backgroundColor: COLORS[2] }}></span> Late ({selectedEmployee.summary?.late})</div>
//                 </div>
//               </div>
//             </div>

//             {/* DAILY ATTENDANCE LOGS TABLE WITH INTERACTIVE FILTERING */}
//             <div className="emppunchhistorytablesection">
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
//                 <h4 style={{ margin: 0 }}>
//                   Daily Attendance {dailyFilter !== "ALL" && (
//                     <span style={{ fontSize: "12px", color: "#6366f1", marginLeft: "6px", fontWeight: "normal" }}>
//                       [Filtered by: {dailyFilter === 'P' ? 'Present' : dailyFilter === 'A' ? 'Absent' : dailyFilter === 'LATE' ? 'Late Marks' : 'Leave Taken'}]
//                     </span>
//                   )}
//                 </h4>
//                 {dailyFilter !== "ALL" && (
//                   <button 
//                     onClick={() => setDailyFilter("ALL")}
//                     style={{ background: "#e2e8f0", border: "none", borderRadius: "6px", padding: "4px 8px", fontSize: "11px", fontWeight: "600", cursor: "pointer", color: "#334155" }}
//                   >
//                     Reset Filter
//                   </button>
//                 )}
//               </div>

//               <table className="emppunchminitableside">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Status</th>
//                     <th>In Time</th>
//                     <th>Remark</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {getFilteredDaily().length === 0 ? (
//                     <tr>
//                       <td colSpan="4" style={{ textAlign: "center", color: "#94a3b8", padding: "16px" }}>
//                         No logs found matching this filter!
//                       </td>
//                     </tr>
//                   ) : (
//                     getFilteredDaily().map((d, i) => {
//                       const isAbsent = d.status === "A" || d.status === "Absent";
//                       const isLate = d.late || d.status?.toLowerCase().includes("late");
//                       const isLeave = (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type;
                      
//                       let remarkText = "On Time";
//                       let remarkClass = "emppunchclrp";

//                       if (isAbsent) {
//                         remarkText = "Absent";
//                         remarkClass = "emppunchclra";
//                       } else if (isLeave) {
//                         remarkText = "Leave Taken";
//                         remarkClass = "emppunchclrl";
//                       } else if (isLate) {
//                         remarkText = d.late_mins ? `Late by ${d.late_mins} mins` : "Late";
//                         remarkClass = "emppunchclrl";
//                       }

//                       return (
//                         <tr key={i}>
//                           <td>{`Day ${d.day}, ${d.date ? d.date.substring(5) : 'Month'}`}</td>
//                           <td>
//                             <span className={`emppunchbadgestatus emppunchst-${(d.status || 'p').toLowerCase()}`}>
//                               {d.status}
//                             </span>
//                           </td>
//                           <td>{d.in_time || "—"}</td>
//                           <td className={`emppunchremtxt ${remarkClass}`}>
//                             {remarkText}
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AttendanceReport;

























import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { Search, ChevronRight, X, Clock, UserCheck, UserMinus, CalendarDays, Calendar } from "lucide-react";
import AttendanceLoader from "./AttendanceLoader";
import "../styles/AttendanceReport.css";

function AttendanceReport() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [dailyFilter, setDailyFilter] = useState("ALL"); // ALL, P, A, LATE, LEAVE
  const [reportMonth, setReportMonth] = useState("");

  const parseJsonSafe = (text) => {
    const jsonStart = text.search(/[\{\[]/);
    if (jsonStart !== -1) {
      return JSON.parse(text.substring(jsonStart));
    }
    return JSON.parse(text);
  };

  useEffect(() => {
    fetch("/gt-api/get_attendance_report.php")
      .then((res) => res.text())
      .then((text) => parseJsonSafe(text))
      .then((result) => {
        const rawList = Array.isArray(result) ? result : [];
        const sanitized = rawList.map((row) => {
          let realAbsent = Number(row.absent || 0);
          if (row.present > 0 && realAbsent >= 8) {
            realAbsent = Math.max(0, realAbsent - 8);
          }
          return { ...row, absent: realAbsent };
        });
        setData(sanitized);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
        setLoading(false);
      });

    fetch("/gt-api/get_department_analytics.php")
      .then((res) => res.text())
      .then((text) => parseJsonSafe(text))
      .then((res) => {
        if (res && res.report_month) {
          const formatted = res.report_month.replace("-", " ");
          setReportMonth(formatted);
        }
      })
      .catch(() => {});
  }, []);

  const filteredData = data.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleEmployeeClick = async (emp_code) => {
    try {
      setDailyFilter("ALL");
      const res = await fetch(`/gt-api/get_employee_attendencedetail.php?emp_code=${emp_code}`);
      const text = await res.text();
      const result = parseJsonSafe(text);
      setSelectedEmployee(result);

      if (result && result.summary) {
        setData((prevData) =>
          prevData.map((item) => {
            if (item.emp_code === emp_code) {
              return {
                ...item,
                present: Number(result.summary.present),
                absent: Number(result.summary.absent),
                late: Number(result.summary.late)
              };
            }
            return item;
          })
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCardClick = (filterType) => {
    if (dailyFilter === filterType) {
      setDailyFilter("ALL");
    } else {
      setDailyFilter(filterType);
    }
  };

  const getFilteredDaily = () => {
    if (!selectedEmployee?.daily) return [];
    if (dailyFilter === "P") return selectedEmployee.daily.filter(d => d.status === "P" || d.status === "Present");
    if (dailyFilter === "A") return selectedEmployee.daily.filter(d => d.status === "A" || d.status === "Absent");
    if (dailyFilter === "LATE") return selectedEmployee.daily.filter(d => d.late || d.status?.toLowerCase().includes("late"));
    if (dailyFilter === "LEAVE") {
      return selectedEmployee.daily.filter(d => 
        (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type || d.remark?.toLowerCase().includes("leave")
      );
    }
    return selectedEmployee.daily;
  };

  const getAbsentCount = () => {
    if (!selectedEmployee) return 0;
    if (selectedEmployee.daily) {
      return selectedEmployee.daily.filter(d => d.status === "A" || d.status === "Absent").length;
    }
    return Number(selectedEmployee.summary?.absent || 0);
  };

  const COLORS = ["#22c55e", "#ef4444", "#f59e0b"];

  const AVATAR_BG_GRADIENTS = [
    "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
    "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
    "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
    "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
    "linear-gradient(135deg, #10b981 0%, #059669 100%)"
  ];

  if (loading) {
    return (
      <AttendanceLoader 
        message="Fetching Attendance Report..." 
        subtitle="Please wait a moment while employee punch records and monthly summaries are processed." 
      />
    );
  }

  return (
    <div className="EmployeePunch">
      {/* LEFT: MAIN EMPLOYEE LIST */}
      <div className={`empppunchmain ${selectedEmployee ? "emppunchactive" : ""}`}>
        <div className="emppunchtopbar">
          <div>
            <div className="title-month-flex-row">
              <h2 className="emppunchtitle">Employee Attendance Summary</h2>
              {reportMonth && (
                <span className="report-month-header-tag">
                  <Calendar size={13} style={{ marginRight: 4 }} />
                  {reportMonth}
                </span>
              )}
            </div>
            <p className="emppunchsubtitle">Click any employee to open complete monthly breakdown</p>
          </div>
          
          <div className="emppunchtoprightactions">
            {reportMonth && (
              <span className="report-month-pill-badge">
                <CalendarDays size={13} style={{ marginRight: 4 }} />
                {reportMonth}
              </span>
            )}
            <span className="emp-count-badge">{filteredData.length} Employees</span>
            <div className="emppunchsearch">
              <Search size={16} className="emppunchsearchicon" />
              <input
                type="text"
                placeholder="Search employee or code..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="emppunchsearchfield"
              />
              {search && (
                <button className="search-clear-btn" onClick={() => setSearch("")}>
                  <X size={14} />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="emppunchtbl">
          <table className="emppunchmaintable">
            <thead>
              <tr>
                <th>Employee Details</th>
                <th>Present</th>
                <th>Absent</th>
                <th>Late</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="5" className="no-emp-found">
                    No employees matching "{search}"
                  </td>
                </tr>
              ) : (
                filteredData.map((row, index) => {
                  const isSelected = selectedEmployee?.emp_code === row.emp_code;
                  const bgGradient = AVATAR_BG_GRADIENTS[index % AVATAR_BG_GRADIENTS.length];

                  return (
                    <tr 
                      key={index} 
                      onClick={() => handleEmployeeClick(row.emp_code)} 
                      className={`emppunchrowitem ${isSelected ? "emppunchrowselected" : ""}`}
                    >
                      <td>
                        <div className="emppunchprofile">
                          <div className="emppunchavatar" style={{ background: bgGradient }}>
                            {row.name ? row.name.charAt(0).toUpperCase() : "E"}
                          </div>
                          <div>
                            <div className="emppunchnamebold">{row.name}</div>
                            <div className="emppunchidsub">EMP #{row.emp_code}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="emppunchtxtp">
                          <UserCheck size={12} style={{ marginRight: 4, display: "inline" }} />
                          {row.present} Days
                        </span>
                      </td>
                      <td>
                        <span className="emppunchtxta">
                          <UserMinus size={12} style={{ marginRight: 4, display: "inline" }} />
                          {row.absent} Days
                        </span>
                      </td>
                      <td>
                        <span className="emppunchtxtl">
                          <Clock size={12} style={{ marginRight: 4, display: "inline" }} />
                          {row.late} Late
                        </span>
                      </td>
                      <td>
                        <div className="view-details-pill-btn">
                          <span>View</span>
                          <ChevronRight size={14} className="chevron-icon-animated" />
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* RIGHT: ELEGANT EMPLOYEE DETAIL PANEL */}
      {selectedEmployee && (
        <div className="emppunchdetailpanel">
          <div className="emppunchpanelheaderblue">
            <div className="emppunchpaneluser">
              <div className="emppunchavatarwhite">
                {selectedEmployee.name ? selectedEmployee.name.charAt(0).toUpperCase() : "E"}
              </div>
              <div>
                <h3>{selectedEmployee.name}</h3>
                <div className="emp-header-subrow">
                  <span className="emppunchidtag">ID: {selectedEmployee.emp_code}</span>
                  <span className="emp-status-pill">Active Record</span>
                </div>
              </div>
            </div>
            <button 
              className="emppunchpanelclose" 
              onClick={() => setSelectedEmployee(null)}
              title="Close Detail View"
            >
              <X size={18} />
            </button>
          </div>

          <div className="emppunchpanelcontentscrollable">
            {/* 4 INTERACTIVE STAT CARDS / TABS */}
            {(() => {
              const leaveCount = selectedEmployee?.summary?.leave !== undefined
                ? selectedEmployee.summary.leave
                : (selectedEmployee?.daily?.filter(d => 
                    (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type || d.status?.toLowerCase().includes("leave")
                  ).length || 0);

              const absentCount = getAbsentCount();

              return (
                <div className="emppunchstatscards">
                  <div 
                    className={`emppunchcarditem emppunchcpresent ${dailyFilter === 'P' ? 'emppunchcardactive' : ''}`}
                    onClick={() => handleCardClick('P')}
                    title="Click to filter Present days"
                  >
                    <div className="stat-card-icon-box present-bg">
                      <UserCheck size={18} color="#22c55e" />
                    </div>
                    <div>
                      <p>Present</p>
                      <strong>{selectedEmployee.summary?.present || 0}</strong>
                    </div>
                  </div>

                  <div 
                    className={`emppunchcarditem emppunchcabsent ${dailyFilter === 'A' ? 'emppunchcardactive' : ''}`}
                    onClick={() => handleCardClick('A')}
                    title="Click to filter Absent days (Excludes Week Off)"
                  >
                    <div className="stat-card-icon-box absent-bg">
                      <UserMinus size={18} color="#ef4444" />
                    </div>
                    <div>
                      <p>Absent</p>
                      <strong>{absentCount}</strong>
                    </div>
                  </div>

                  <div 
                    className={`emppunchcarditem emppunchclate ${dailyFilter === 'LATE' ? 'emppunchcardactive' : ''}`}
                    onClick={() => handleCardClick('LATE')}
                    title="Click to filter Late marks"
                  >
                    <div className="stat-card-icon-box late-bg">
                      <Clock size={18} color="#f59e0b" />
                    </div>
                    <div>
                      <p>Late</p>
                      <strong>{selectedEmployee.summary?.late || 0}</strong>
                    </div>
                  </div>

                  <div 
                    className={`emppunchcarditem emppunchcleave ${dailyFilter === 'LEAVE' ? 'emppunchcardactive' : ''}`}
                    onClick={() => handleCardClick('LEAVE')}
                    title="Click to filter Leave days"
                  >
                    <div className="stat-card-icon-box leave-bg">
                      <CalendarDays size={18} color="#8b5cf6" />
                    </div>
                    <div>
                      <p>Leave</p>
                      <strong>{leaveCount}</strong>
                    </div>
                  </div>
                </div>
              );
            })()}

            {/* OVERVIEW DONUT CHART */}
            <div className="emppunchanalyticssectionwhite">
              <div className="analytics-card-header">
                <h4>Monthly Distribution Overview</h4>
                <span className="analytics-subtitle">Breakdown of recorded punch days</span>
              </div>
              <div className="emppunchchartbox">
                <div className="emppunchchartleft">
                  <ResponsiveContainer width="100%" height={180}>
                    <PieChart>
                      <Pie
                        data={[
                          { name: "Present", value: Number(selectedEmployee.summary?.present || 0) },
                          { name: "Absent", value: Number(getAbsentCount()) },
                          { name: "Late", value: Number(selectedEmployee.summary?.late || 0) }
                        ]}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={75}
                        dataKey="value"
                        stroke="#fff"
                        strokeWidth={2}
                      >
                        {COLORS.map((color, i) => (
                          <Cell key={`cell-${i}`} fill={color} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>

                <div className="emppunchchartlegendright">
                  <div className="emppunchlegendrow">
                    <span className="emppunchdot" style={{ backgroundColor: COLORS[0] }}></span>
                    <span className="legend-label">Present:</span> 
                    <strong>{selectedEmployee.summary?.present} days</strong>
                  </div>
                  <div className="emppunchlegendrow">
                    <span className="emppunchdot" style={{ backgroundColor: COLORS[1] }}></span>
                    <span className="legend-label">Absent:</span> 
                    <strong>{getAbsentCount()} days</strong>
                  </div>
                  <div className="emppunchlegendrow">
                    <span className="emppunchdot" style={{ backgroundColor: COLORS[2] }}></span>
                    <span className="legend-label">Late:</span> 
                    <strong>{selectedEmployee.summary?.late} times</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* DAILY ATTENDANCE LOGS TABLE WITH INTERACTIVE FILTERING */}
            <div className="emppunchhistorytablesection">
              <div className="history-table-header-row">
                <h4>
                  Daily Punch Log {dailyFilter !== "ALL" && (
                    <span className="active-filter-tag">
                      Filtered: {dailyFilter === 'P' ? 'Present Days' : dailyFilter === 'A' ? 'Absent Days' : dailyFilter === 'LATE' ? 'Late Marks' : 'Leave Taken'}
                    </span>
                  )}
                </h4>
                {dailyFilter !== "ALL" && (
                  <button 
                    onClick={() => setDailyFilter("ALL")}
                    className="reset-filter-btn"
                  >
                    Reset Filter
                  </button>
                )}
              </div>

              <table className="emppunchminitableside">
                <thead>
                  <tr>
                    <th>Day / Date</th>
                    <th>Status</th>
                    <th>Punch In Time</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {getFilteredDaily().length === 0 ? (
                    <tr>
                      <td colSpan="4" className="empty-daily-logs">
                        No attendance records matching this filter.
                      </td>
                    </tr>
                  ) : (
                    getFilteredDaily().map((d, i) => {
                      const isAbsent = d.status === "A" || d.status === "Absent";
                      const isLate = d.late || d.status?.toLowerCase().includes("late");
                      const isLeave = (d.status !== "P" && d.status !== "A" && d.status !== "WO" && d.status !== "HL") || d.leave_type;
                      
                      let remarkText = "On Time";
                      let remarkClass = "emppunchclrp";

                      if (isAbsent) {
                        remarkText = "Absent";
                        remarkClass = "emppunchclra";
                      } else if (isLeave) {
                        remarkText = "Leave Taken";
                        remarkClass = "emppunchclrl";
                      } else if (isLate) {
                        remarkText = d.late_mins ? `Late by ${d.late_mins}m` : "Late Arrival";
                        remarkClass = "emppunchclrl";
                      }

                      return (
                        <tr key={i} className="daily-log-row">
                          <td className="daily-date-cell">
                            {`Day ${d.day}, ${d.date ? d.date.substring(5) : ''}`}
                          </td>
                          <td>
                            <span className={`emppunchbadgestatus emppunchst-${(d.status || 'p').toLowerCase()}`}>
                              {d.status}
                            </span>
                          </td>
                          <td className="daily-intime-cell">{d.in_time || "—"}</td>
                          <td>
                            <span className={`remark-badge ${remarkClass}`}>
                              {remarkText}
                            </span>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AttendanceReport;